import { get } from 'lodash';
import { RegionType } from '@wix/shoutout-email-model-v3';
import { extractTextStyles, getSecondaryButton } from '../../utils/elements';
import { calculateLineHeightInPx } from '../../utils/inject-mobile-line-height-class';
import { defaultLineHeight, defaultTextSize } from '../../utils/defaults';
import { getContentWidth } from '../../utils/get-message-width';
import * as cssUtils from '../../utils/css-utils';
import { extractInputFieldStyles } from '../../utils/elements/extract-input-field-styles';
// not a good location for this function
const titleClassName = 'so-global-h3';
const inputClassName = 'so-global-region-subscribe';
export const getSubscribeSection = ({ css, isRtl, region, composerData, }) => {
    if (region.type !== RegionType.Subscribe) {
        throw Error('Subscribe must be passed');
    }
    const trimText = (text, length) => text.substring(0, length);
    const defaultTitleStyle = get(css, titleClassName) || {};
    const defaultInputStyle = get(css, inputClassName) || {};
    const customTitleStyle = get(region, 'data.styles.title') || {};
    const customInputFieldStyle = get(region, 'data.styles.inputField') || {};
    // 18 seems to be a save maximum amount of character we can show
    // in one column on mobile.
    const maxCharsPerLine = 18;
    const extractedTextStyles = extractTextStyles(customTitleStyle, defaultTitleStyle);
    const extractedInputFieldStyles = extractInputFieldStyles(customInputFieldStyle, defaultInputStyle);
    const titleStyles = {
        lineHeight: calculateLineHeightInPx(defaultTitleStyle.lineHeight || defaultLineHeight, extractedTextStyles.fontSize || `${defaultTextSize}px`),
        ...extractedTextStyles,
    };
    function getPlaceholderText() {
        const placeholderText = get(region, 'data.placeholderText', undefined);
        if (placeholderText) {
            return trimText(placeholderText, maxCharsPerLine);
        }
        return undefined;
    }
    const p1Style = get(css, 'so-global-p1', {});
    const consentTextStyle = Object.keys(p1Style).reduce((result, prop) => {
        if (p1Style[prop]) {
            result[prop] = p1Style[prop];
        }
        return result;
    }, {});
    const rules = [css['so-global-region-subscribe'], css['so-global-region']];
    const visibility = get(region, 'data.visibility');
    const mobileCssClass = cssUtils.getRegionMobileCssClass(rules, false, visibility);
    const margin = cssUtils.margin(rules);
    const padding = cssUtils.padding(rules);
    const titleOuterPadding = { ...margin, bottom: 0 };
    const titleInnerPadding = { ...padding, bottom: 15 };
    const titleCssClass = cssUtils.getTopPaddingRestrictionCssClass(rules);
    const formOuterPadding = { ...margin, top: 0 };
    const formInnerPadding = { ...padding, top: 0 };
    const formCssClass = cssUtils.getBottomPaddingRestrictionCssClass(rules);
    const contentWidth = getContentWidth(composerData, css, rules) -
        (padding.left || 0) -
        (padding.right || 0);
    const columnsWidths = cssUtils
        .calculateColumnsProportions(contentWidth, [70, 30], padding, isRtl)
        .map((val) => `${val}%`);
    return {
        widthsForMediaQueries: columnsWidths,
        button: getSecondaryButton(css, get(region, 'data.styles.button', {}), trimText(region.data.buttonText, maxCharsPerLine), region.trackedLinkToRegion),
        inputField: extractedInputFieldStyles,
        title: {
            ...titleStyles,
            text: region.data.title,
        },
        consent: {
            shouldRequireConsent: get(region, 'data.shouldRequireConsent', false),
            consentCheckboxText: region.data.consentCheckboxText,
            shouldShowConsentLink: region.data.shouldShowConsentLink,
            consentLinkText: region.data.consentLinkText,
            consentLinkUrl: region.data.consentLinkUrl,
            consentTextStyle,
        },
        placeholderText: getPlaceholderText(),
        titleOuterPadding,
        titleInnerPadding,
        formOuterPadding,
        formInnerPadding,
        cssClass: mobileCssClass,
        titleCssClass,
        formCssClass,
        columnsWidths,
        successMessage: region.data.successMessage,
        errorMessage: region.data.errorMessage,
        visibility,
    };
};
//# sourceMappingURL=get-subscribe-section.js.map